import * as React from "react";
import { Box, Button, Typography, Alert } from "@mui/material";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";

export default function UserPackagesQuery(props) {
  const { getUserPackagesFromBack, setQueryFetchedUserCodesData } = props
  const [selectedPackage, setSelectedPackage] = React.useState("all");

  const handleSelectedPackage = (e) => {
    setSelectedPackage(e.target.value)
    // console.log("131",)
  }
  const clicktoback = () => {
    //   const data=JSON.stringify({
    //     validation: selectedPackage
    // })
    const data = {
      validation: selectedPackage
    }
    for (const property in data) {
      if (typeof data[property] == "boolean") continue;
      if (!data[property]) delete data[property];
    }
    setQueryFetchedUserCodesData(data);
    getUserPackagesFromBack("getUserPackagesApi", data)

  }
  return (
    <Box
      sx={{
        textAlign: "center",
        my: 1,
      }}
    >
      <FormControl>
        <Typography variant="h6" gutterBottom>
          پکیج های من
        </Typography>
        <RadioGroup
          row
          aria-labelledby="selectedPackages"
          name="selectedPackages"
          onChange={handleSelectedPackage}
        // value={selectedPackage}
        >
          <FormControlLabel value="true" control={<Radio />} label="معتبر" />
          <FormControlLabel
            value="false"
            control={<Radio />}
            label="نامعتبر"
          />
          <FormControlLabel value="all" control={<Radio />} label="همه" />
        </RadioGroup>
        <Button onClick={clicktoback} variant="contained">مشاهده</Button>
      </FormControl>
    </Box>
  );
}
